import { ModelBase } from "../../Core/Models/ModelBase";
import * as MobX from "mobx";
import { IsNotEmpty } from "class-validator";
import { CARD_TYPE } from "../../Custom/ViewModels/CardPaymentViewModel";

export class CardPaymentModel extends ModelBase<CardPaymentModel, CardPaymentModelDTO> {
    @IsNotEmpty({ message: "Name is required" })
    @MobX.observable
    public name: string = "";

    // These fields are no longer directly used with Stripe Elements
    // but kept for backward compatibility
    @MobX.observable
    public cardNumber: string = "";

    @MobX.observable
    public security: string = "";

    @MobX.observable
    public expiry: Date | null = null;

    constructor() {
        super();
    }

    public fromDto = (model: CardPaymentModelDTO) => {
        if (model) {
            this.name = model.name || "";
        }
    };

    public toDto = (model: CardPaymentModel): CardPaymentModelDTO => {
        return {
            name: model.name,
            expiry: null,
            security: "",
            cardNumber: "",
        };
    };
}

export interface CardPaymentModelDTO {
    name: string;
    expiry: Date | null;
    security: string;
    cardNumber: string;
}
